import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IKlaviyoCredentials {
    api_key: string,
};

class KlaviyoCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IKlaviyoCredentials = {} as IKlaviyoCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get api_key() { return this._changes.api_key; }

    public set api_key(v: string) { this._changes.api_key = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IKlaviyoCredentials;
    }

    public getUpdatedModel(): IKlaviyoCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default KlaviyoCredentialsStore;
